import { action } from 'typesafe-actions'
import { TrackerPolicy } from '@models/tracker-policy'
import {RequestData} from "@models/axios";


export const enum TrackerPoliciesActionTypes {
    FETCH_REQUEST = '@@trackerPolicies/FETCH_REQUEST',
    FETCH_SUCCESS = '@@trackerPolicies/FETCH_SUCCESS',
    FETCH_ERROR = '@@trackerPolicies/FETCH_ERROR',

    DELETE_REQUEST = '@@trackerPolicies/DELETE_REQUEST',
    DELETE_SUCCESS = '@@trackerPolicies/DELETE_SUCCESS',
    DELETE_ERROR = '@@trackerPolicies/DELETE_ERROR',

    CREATE_REQUEST = '@@trackerPolicies/CREATE_REQUEST',
    CREATE_SUCCESS = '@@trackerPolicies/CREATE_SUCCESS',
    CREATE_ERROR = '@@trackerPolicies/CREATE_ERROR',

    UPDATE_REQUEST = '@@trackerPolicies/UPDATE_REQUEST',
    UPDATE_SUCCESS = '@@trackerPolicies/UPDATE_SUCCESS',
    UPDATE_ERROR = '@@trackerPolicies/UPDATE_ERROR',

    FETCH_ITEM_REQUEST = '@@trackerPolicies/FETCH_ITEM_REQUEST',
    FETCH_ITEM_SUCCESS = '@@trackerPolicies/FETCH_ITEM_SUCCESS',
    FETCH_ITEM_ERROR = '@@trackerPolicies/FETCH_ITEM_ERROR',
}


export const fetchRequest = (data:RequestData) => action(TrackerPoliciesActionTypes.FETCH_REQUEST, data);
export const fetchSuccess = (data: TrackerPolicy[]) => action(TrackerPoliciesActionTypes.FETCH_SUCCESS, data);
export const fetchError = (message: string) => action(TrackerPoliciesActionTypes.FETCH_ERROR, message);

export const deleteRequest = (data:RequestData) => action(TrackerPoliciesActionTypes.DELETE_REQUEST, data);
export const deleteSuccess = (data:any) => action(TrackerPoliciesActionTypes.DELETE_SUCCESS, data);
export const deleteError = (message: string) => action(TrackerPoliciesActionTypes.DELETE_ERROR, message);

export const createRequest = (data:RequestData) => action(TrackerPoliciesActionTypes.CREATE_REQUEST, data);
export const createSuccess = (data: TrackerPolicy[]) => action(TrackerPoliciesActionTypes.CREATE_SUCCESS, data);
export const createError = (message: string) => action(TrackerPoliciesActionTypes.CREATE_ERROR, message);

export const updateRequest = (data:RequestData) => action(TrackerPoliciesActionTypes.UPDATE_REQUEST, data);
export const updateSuccess = (data: TrackerPolicy[]) => action(TrackerPoliciesActionTypes.UPDATE_SUCCESS, data);
export const updateError = (message: string) => action(TrackerPoliciesActionTypes.UPDATE_ERROR, message);

export const fetchItemRequest = (data:RequestData) => action(TrackerPoliciesActionTypes.FETCH_ITEM_REQUEST, data);
export const fetchItemSuccess = (data: TrackerPolicy[]) => action(TrackerPoliciesActionTypes.FETCH_ITEM_SUCCESS, data);
export const fetchItemError = (message: string) => action(TrackerPoliciesActionTypes.FETCH_ITEM_ERROR, message);